// extracted by mini-css-extract-plugin
export var growableInput = "_65-0";
export var tagContainer = "_65-2";
export var textInput = "_65-1";